import { type InstagramCookieCredentials } from '@unipile/provider-instagram';
import { Alert, AlertDescription, Button, Field, FieldGroup, FieldLabel, Input, LocationConfig, Spinner } from '@unipile/ui';
import { InfoIcon } from 'lucide-react';
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type CookiesFormValues = Pick<InstagramCookieCredentials, 'sessionid'>;

export function CookiesForm({
  onSubmit,
  isPending,
}: {
  onSubmit: (data: InstagramCookieCredentials) => void;
  isPending?: boolean;
}) {
  const form = useForm<CookiesFormValues>({
    defaultValues: {
      sessionid: '',
    },
  });
  const { t } = useTranslation();

  return (
    <form onSubmit={form.handleSubmit(onSubmit)} className="mt-8 space-y-4">
      <Alert>
        <InfoIcon />
        <AlertDescription>{t('LoginScreen.cookies.warning', { ns: 'instagram' })}</AlertDescription>
      </Alert>
      <FieldGroup>
        <Controller
          control={form.control}
          name="sessionid"
          rules={{ required: t('LoginScreen.form.sessionid.required', { ns: 'instagram' }) }}
          render={({ field }) => (
            <Field>
              <FieldLabel>
                {t('LoginScreen.form.sessionid.label', { ns: 'instagram' })}
                <code className="text-muted-foreground bg-muted ml-1 rounded-md px-1 text-xs">sessionid</code>
              </FieldLabel>
              <Input placeholder="123456789%3Aabcdef..." {...field} />
            </Field>
          )}
        />

        <LocationConfig provider="instagram" />
        <Button type="submit" disabled={isPending}>
          {isPending && <Spinner />}
          {t('Common.next')}
        </Button>
      </FieldGroup>
    </form>
  );
}
